var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:"nav-link pl-2 pr-1 mx-1 py-3 my-n2",attrs:{"id":"mini-cart"},on:{"click":_vm.toggleMiniCart}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" "),(_vm.itemCount !== 0)?_c('span',{staticClass:"badge",domProps:{"textContent":_vm._s(_vm.itemCount)}}):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bf9686a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/mini-cart-button.vue
// module id = XVoQ
// module chunks = 0